export function getLocationId(location) {
  return location?.id ?? location?.location_id;
}

export function getLocationName(location) {
  return location?.name ?? location?.location_name ?? '';
}

export function getLocationStatus(location) {
  const status = location?.locationStatus ?? location?.location_status ?? '';
  return String(status).toLowerCase();
}

export function isDraftLocation(location) {
  return getLocationStatus(location) === 'draft';
}

export function isDisabledLocation(location) {
  return getLocationStatus(location) === 'disabled';
}

export function getLocationStatusColor(location) {
  if (isDisabledLocation(location)) return '#EF4444';
  if (isDraftLocation(location)) return '#CECE12';
  return '#2C313A';
}

export function getLocationDisplayName(entity) {
  return entity?.name ?? entity?.location_name ?? '';
}

export function getAnalyticsId(entity) {
  return entity?.gAnalyticsId ?? entity?.g_analytics_id ?? '';
}

export function getPropertyDisplayName(entity) {
  return entity?.property_name ?? entity?.propertyName ?? entity?.name ?? '';
}

export function getCompanyDisplayName(entity) {
  return entity?.company_name ?? entity?.companyName ?? entity?.name ?? '';
}

export function getSubdivisionCode(principalSubdivisionCode) {
  if (principalSubdivisionCode == null) return '';

  const value = String(principalSubdivisionCode).trim();
  if (!value || value === 'undefined' || value === 'null') return '';

  const parts = value.split('-').filter(Boolean);
  const code = (parts.length > 1 ? parts[parts.length - 1] : parts[0]).trim();

  return code && code !== 'undefined' && code !== 'null' ? code : '';
}

export function aggregateLocationVisits(items) {
  if (!Array.isArray(items)) return [];

  const byCity = {};

  items.forEach(item => {
    const city = String(item?.city || item?.locality || '').trim();
    if (!city) return;

    const subdivision = getSubdivisionCode(item?.principalSubdivisionCode);
    if (!byCity[city]) {
      byCity[city] = { visits: 0, subdivision: '' };
    }

    byCity[city].visits += Number(item?.visitsCount) || 0;
    if (subdivision && !byCity[city].subdivision) {
      byCity[city].subdivision = subdivision;
    }
  });

  return Object.entries(byCity)
    .map(([city, { visits, subdivision }]) => [
      subdivision ? `${city}, ${subdivision}` : city,
      visits,
    ])
    .sort((a, b) => b[1] - a[1]);
}
